<!-- @format -->

<template>
    <div
        :ref="'room-' + item.id"
        class="gst-room-card-variant-2">
        <div class="gst-room-card-variant-2__room-details px-4 py-md-4">
            <RoomCarousel :images="item.images" />
            <div class="amenities-container u-width-100">
                <h6 class="room-name">
                    {{ item | roomName }}
                </h6>
                <RoomAmenities
                    v-if="amenities"
                    :amenities="amenities" />
            </div>
        </div>
        <div class="gst-room-card-variant-2__offers d-flex flex-column align-self-stretch">
            <RoomOffer
                v-for="(rate, index) in item.rates"
                :key="index"
                class="offer"
                :rate="rate"
                :bundle-products="bundleProductsWithCurrentRoom"
                :selected="isRateSelected(rate)"
                @click="selectRoomWithRate(rate)" />
        </div>
    </div>
</template>

<script>
import { create as CreateBundleProductsModel } from '@tenant/app/modelsV2/BundleProductsModel';
import RoomCarousel from './RoomCardVariant2/RoomCarousel';
import RoomOffer from './RoomCardVariant2/RoomOffer';
import RoomAmenities from './RoomCardVariant2/RoomAmenities.vue';

export default {
    name: 'RoomCardVariant2',
    components: {
        RoomCarousel,
        RoomOffer,
        RoomAmenities,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        bundleProducts: {
            type: Object,
            default: function () {
                return CreateBundleProductsModel();
            },
        },
        isRoomSelected: {
            type: Boolean,
            default: false,
        },
        isRoomFocused: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        amenities() {
            return this.item.amenities;
        },
        bundleProductsWithCurrentRoom() {
            const ret = this.bundleProducts._clone();
            ret.hotelReservation.hotel.selectedRoom = this.item;

            ret.setHotelReservationSelectRoom(this.item);

            return ret;
        },
    },
    methods: {
        selectRoomWithRate(selectedRate) {
            /**
             * TODO ionutt
             * THIS IS a bug.
             * We are changing elements stored in Vuex
             */
            const selectedRoomWithRate = this.item;
            selectedRoomWithRate.selectedRate = selectedRate;
            this.$emit('click', selectedRoomWithRate);
        },
        isRateSelected(rate) {
            if (!this.isRoomSelected) {
                return false;
            }

            return rate.id === this.item.selectedRate.id;
        },
    },
    mounted() {
        this.$nextTick(() => {
            if (this.isRoomFocused) {
                this.$emit('focusedRoomMounted', this.$refs['room-' + this.item.id]);
            }
        });
    },
};
</script>

<style lang="scss">
@import '@scssVariables';
@import '@scssMixins';

.gst-room-card-variant-2 {
    display: flex;
    border: 1px solid theme-color-hex('senary-darken-2');
    align-items: center;
    flex-direction: row;

    .gst-room-card-variant-2__room-details {
        display: flex;
        max-width: 33%;
        flex-direction: column;
        border-right: 1px solid theme-color-hex('senary-darken-2');
        align-self: stretch;
        align-items: center;

        .amenities-container {
            display: flex;
            margin-top: theme-spacing(3);
            flex: 1;
            flex-direction: column;
            align-items: flex-start;
            max-width: 270px;

            .room-name {
                line-height: line-height('xl');
                color: theme-color('quaternary');
                font-size: font-size('s');
                font-weight: font-weight('large');
            }
        }
    }

    .gst-room-card-variant-2__offers {
        width: 100%;

        .offer {
            align-items: stretch;
            flex: 1 1 auto;
            border-bottom: 1px solid theme-color-hex('senary-darken-2');

            &:last-child {
                border-bottom: 0;
            }
        }
    }

    @include mobile-only {
        border: 0;
        flex-direction: column;

        .gst-room-card-variant-2__room-details {
            min-width: 100%;

            .amenities-container {
                width: 100%;
                padding: 12px 0;
                margin-top: 0;
                max-width: unset;

                .room-name {
                    padding: 0;
                }

                .amenities {
                    height: auto;
                    padding: 0;
                }
            }
        }

        .gst-room-card-variant-2__offers {
            .offer {
                border: 1px solid theme-color-hex('senary');
                margin: theme-spacing(0, 4, 4, 4);
                border-radius: border-radius('xxs');

                &:last-child {
                    border: 1px solid theme-color-hex('senary');
                    margin-bottom: theme-spacing(0);
                }
            }
        }
    }
}

.gst-room-card-variant-2:last-child {
    @include mobile-only {
        margin-bottom: theme-spacing(4);
    }
}
</style>
